import React from 'react'
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

interface propType  {
    label?: string,
    value?: string,
    onChange: (e: string) => void,
    onFocus?: (e: string) => void,
    onBlur?: (e: string) => void,
    onKeyDown?: (e :{key: string}) => void,
    type?: string,
    placeholder?: string,
    startAdornment?: React.ReactNode,
    endAdornment? : React.ReactNode,
    error?: boolean,
    errorMsg?: string,
    inputClasses?: string,
    containerClasses?: string,
    labelShrink?: boolean,
    className?: string
}

const InputComponent = (props: propType) => {

    return (
        <>
            <FormControl className={`InputContainer ${props.containerClasses} ${props.className}`} fullWidth error={props.error}>
                {props.label ?
                <InputLabel 
                shrink= {props.labelShrink && props.labelShrink}
                >{props.label}</InputLabel>
                : null}
                <Input
                    className = {`inputComponentDS ${props.inputClasses}`}
                    value = {props.value}
                    type = {props.type || 'text'}
                    placeholder={ props.placeholder || '' }
                    onChange={(e) => props.onChange(e.target.value)}
                    onFocus = {e => props.onFocus && props.onFocus(e.target.value)}
                    onBlur = {e => props.onBlur && props.onBlur(e.target.value)}
                    onKeyDown = { e => props.onKeyDown && props.onKeyDown(e) }
                    startAdornment = {
                        props.startAdornment ?
                        <InputAdornment className="inputIcon" position="start">
                            {props.startAdornment}
                        </InputAdornment>
                        : null
                    }
                    endAdornment={
                        props.endAdornment ?
                        <InputAdornment className="inputIcon" position="start">
                            {props.endAdornment}
                        </InputAdornment>
                        : null
                    }
                />
                {  props.errorMsg ?
                    <FormHelperText>{props.errorMsg}</FormHelperText>
                 : null}
            </FormControl>
        </>
    )
}

export default InputComponent
